import { create } from "zustand";

/** Open state for the Tools overlay.
 *
 * Its own store, not a field on the shell store, because the overlay is summoned
 * from four places (the rail button, the keyboard, the command palette and the
 * empty-state prompts) and none of them should have to reach through the shell. */
interface ToolsOverlayState {
  open: boolean;
  /** The group scrolled to on open, when a caller wants a specific one. */
  focusGroup: string | null;
  openTools: (focusGroup?: string) => void;
  closeTools: () => void;
  toggleTools: () => void;
}

export const useToolsOverlay = create<ToolsOverlayState>((set, get) => ({
  open: false,
  focusGroup: null,
  openTools: (focusGroup) => set({ open: true, focusGroup: focusGroup ?? null }),
  closeTools: () => set({ open: false, focusGroup: null }),
  toggleTools: () => (get().open ? get().closeTools() : get().openTools()),
}));
